import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IExposedAddress, ILab, IModifyAddress, INewAddress } from "@gloria-public/order/domain/interfaces/address.interface";
import { ApiService } from "@shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AddressService {
  constructor(private api: ApiService) {}

  /**
   * Recover all client's addresses
   * @returns A list of user addresses
   */
  public getUserAddresses(): Observable<IExposedAddress[]> {
    return this.api.get("addresses") as Observable<IExposedAddress[]>;
  }

  /**
   * Add a new address to a client
   * @param newAddress User's new address
   * @returns The newly saved address
   */
  public addAddress(newAddress: INewAddress): Observable<IExposedAddress> {
    return this.api.post("addresses", newAddress) as Observable<IExposedAddress>;
  }

  /**
   * Modify an existing client's address
   * @param id The address id that needs the changes
   * @param updatedAddress The updated address
   * @returns Success or error
   */
  public modifyAddress(id: number, updatedAddress: IModifyAddress): Observable<HttpResponse<number>> {
    return this.api.patchResponse(`addresses/${encodeURIComponent(id)}`, updatedAddress) as Observable<HttpResponse<number>>;
  }

  /**
   * Recover labs' addresses
   * @param postalCode optional postal code for filtering
   * @param id optional lab id for filtering
   * @returns A list of available labs
   */
  public getLabs(postalCode?: string, id?: string): Observable<ILab[]> {
    const params: Record<string, string> = {};

    if (postalCode) params["postalCode"] = postalCode.trim();
    if (id) params["id"] = id;

    return this.api.get("labs", params) as Observable<ILab[]>;
  }
}
